import moment from 'moment'
import http from '@/http'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'auth/'

const defaultState = () => {
  return {
    inviteUser: null,
    invitedVideoRoom: null
  }
}

const state = defaultState()

const getters = {
  inviteUser: state => state.inviteUser,
  invitedVideoRoom: state => state.invitedVideoRoom
}

const mutations = {
  inviteUser(state, payload) {
    state.inviteUser = payload
  },
  invitedVideoRoom(state, payload) {
    state.invitedVideoRoom = payload
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
  async validateInviteToken({ commit }, token) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    await http({
      url: tmpURL + API_PATH + 'invite_token_validations/' + serializeObjectToQueryParameter({
        invite_token: token
      })
    }).then(response => {
      commit('inviteUser', response.data)
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async reject({ commit }, token) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    await http({
      url: tmpURL + API_PATH + 'invite_token_validations/',
      method: 'DELETE',
      data: {
        invite_token: token
      }
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async validateGuestToken({ commit }, token) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    await http({
      url: tmpURL + API_PATH + 'guest_token_validations/' + serializeObjectToQueryParameter({
        guest_token: token
      })
    }).then(response => {
      // NOTE: 擬似的にVideoRoomモデル(models/VideoRoom.js)と同じインターフェースとする
      const invitedVideoRoom = Object.assign(response.data.data.attributes, {
        users: response.data.included.filter((resource) => resource.type === 'user').map(user => user.attributes),
        myMember: response.data.included.filter((resource) => resource.type === 'videoRoomMember' && resource.id == response.data.data.attributes.myMemberId)[0]?.attributes
      })
      invitedVideoRoom.isWaitable = function() {
        if (this.inDuration) return false
        const diffMinutes = moment(this.startAt).diff(moment(new Date), 'minutes')
        return diffMinutes >= 0 && diffMinutes <= 10
      }
      commit('invitedVideoRoom', invitedVideoRoom)
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async guestForceExit({ commit }, token) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    await http({
      url: tmpURL + API_PATH + 'guest_token_validations/force_exit/',
      method: 'PUT',
      data: {
        guest_token: token
      }
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
